<template>
  <section>
    <Navbar :data="data" />
    <div class="ucl-proposition">
      <div class="ucl-proposition__hero">
        <img
          :src="require(`../assets/images/${data.logo}.png`)"
          class="animate__animated animate__bounceInDown"
        />
        <h1 class="animate__animated animate__bounceInUp">{{ data.title }}</h1>
        <h3 class="animate__animated animate__bounceInUp">
          {{ data.subtitle }}
        </h3>
        <h3 class="animate__animated animate__bounceInUp">
          {{ data.deal }}
        </h3>
        <p class="animate__animated animate__bounceInUp">{{ data.info }}</p>
      </div>
      <div class="ucl-proposition__restaurants">
        <a
          v-for="(restaurant, i) in data.restaurants"
          :key="`restaurant__${i}`"
          :href="restaurant.link"
          target="_blank"
          class="ucl-proposition__restaurants--container"
        >
          <div class="logo">
            <img :src="require(`../assets/images/${restaurant.image}.png`)" />
          </div>
          <div class="name">
            <h4>{{ restaurant.name }}</h4>
          </div>
        </a>
      </div>
      <div class="ucl-proposition__terms">
        <h3 class="animate__animated animate__bounceInUp">
          {{ data.matches.title }}
        </h3>
        <ul class="animate__animated animate__bounceInUp">
          <li v-for="(date, i) in data.matches.dates" :key="`date__${i}`">
            {{ date }}
          </li>
          <p>{{ data.matches.outro }}</p>
        </ul>
        <a :href="data.button.url" target="_blank">{{ data.button.text }}</a>
        <h4>{{ data.terms.title }}</h4>
        <ul>
          <li
            v-for="(condition, i) in data.terms.conditions"
            :key="`condition__${i}`"
          >
            {{ condition }}
          </li>
        </ul>
      </div>
      <div class="ucl-proposition__footer">
        <div class="ucl-proposition__footer--stores">
          <a :href="data.app.apple" target="_blank"
            ><img src="../assets/images/apple.png"
          /></a>
          <a :href="data.app.google" target="_blank"
            ><img class="google" src="../assets/images/google.png"
          /></a>
        </div>
        <div class="ucl-proposition__footer--links">
          <a :href="data.conditions.url">{{ data.conditions.link }}</a>
          <a :href="data.privacy.url">{{ data.privacy.link }}</a>
        </div>
        <p>{{ data.copyright }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import Navbar from '../components/Navbar.vue'

export default {
  name: 'FoodTrends',
  components: {
    Navbar,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
    locality: {
      type: String,
      default: '',
      required: true,
    },
  },
}
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

.ucl-proposition {
  width: 100%;
  position: relative;
  margin: 0 auto;
  margin-top: -150px;
  &__hero {
    background-image: url('../assets/images/background.png');
    padding: 100px 10% 50px;
    text-align: center;
    background-position: top;
    @media (max-width: $tablet) {
      padding: 150px 5% 50px;
    }
    img {
      width: 300px;
    }
    h1,
    p,
    h3,
    li,
    h4 {
      color: white;
    }
  }
  &__restaurants {
    background-color: var(--color-white-1);
    padding: 50px 10% 75px;
    text-align: center;
    display: flex;
    justify-content: center;
    @media (max-width: $tablet) {
      flex-direction: column;
      padding: 50px 5% 70px;
    }
    &--container {
      text-decoration: none;
      width: 25%;
      margin: 0 1%;
      -webkit-box-shadow: 20px 20px 20px 20px rgba(179, 179, 179, 0.7);
      box-shadow: 20px 20px 20px 20px rgba(179, 179, 179, 0.7);
      border-radius: 30px 30px 0 0;
      background-color: var(--color-white-1);
      @media (max-width: $tablet) {
        width: 90% !important;
        margin: 20px 5% !important;
      }
      &:hover {
        transform: scale(1.03);
      }
      .logo {
        cursor: pointer;
        height: 90%;
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        img {
          width: 50%;
          padding: 10px 2%;
        }
      }
      .name {
        color: var(--color-white-1);
        background-color: var(--color-blue-1);
        position: relative;
        display: flow-root;
        border-radius: 0 0 30px 30px;
        h4 {
          margin: 15px;
        }
      }
    }
  }
  &__terms {
    background-image: url('../assets/images/background.png');
    text-align: center;
    background-position: top;
    padding: 50px 10%;
    text-align: center;
    @media (max-width: $tablet) {
      flex-direction: column;
      padding: 50px 5%;
    }
    h4,
    h3 {
      color: var(--color-white-1);
    }
    h4 {
      padding-top: 20px;
    }
    ul {
      list-style: none;
      padding: 0;
      list-style: none;
      margin-bottom: 50px;
      padding: 0;
      li,
      p {
        color: var(--color-white-1);
      }
    }
    a {
      background-color: var(--color-blue-1);
      color: white;
      padding: 15px 30px;
      border-radius: 30px;
      text-decoration: none;
      cursor: pointer;
      font-size: 20px;
      display: block;
      width: 200px;
      margin: 0 auto;
      &:hover {
        transform: scale(1.03);
      }
    }
  }
  &__footer {
    background-color: var(--color-mozzarella-1);
    padding: 20px;
    text-align: center;
    &--links {
      display: flex;
      flex-direction: column;
      a {
        margin: 5px 0;
      }
    }
    &--stores {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 150px;
        cursor: pointer;
        &:hover {
          transform: scale(1.03);
        }
      }
      .google {
        width: 190px;
      }
    }
    p {
      font-size: 14px;
      color: var(--color-charcoal-1);
      font-weight: 600;
    }
  }
}
</style>